"use client";
import { useMemo as p, useCallback as g } from "react";
import f from "../../../hooks/useHandleStateClick.js";
import { cn as k } from "../../../utils/cn.js";
import { dataBooleanAttr as m } from "../../../utils/dataBooleanAttr.js";
function I(u) {
  const {
    ref: e,
    color: s = "current",
    size: t = 6,
    loading: o,
    disabled: r,
    onClick: c,
    className: n,
    ...a
  } = u, i = f(
    c,
    o,
    r
  ), l = p(
    () => ({
      "--icon-size": `calc(var(--spacing) * ${t})`,
      "--icon-color": s === "current" ? "currentColor" : `var(--color-${s})`
    }),
    [s, t]
  ), d = p(
    () => k("size-(--icon-size) shrink-0", c && "cursor-pointer", n),
    [n, c]
  );
  return g(
    (v = {}) => ({
      "data-loading": m(o),
      "data-disabled": m(r),
      ...a,
      ref: e,
      className: d,
      style: l,
      onClick: i,
      disabled: r || o
    }),
    [d, r, i, o, a, e, l]
  );
}
export {
  I as useSvgIcon
};
